/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { RootStoreType } from './index'

/**
 * ChapterBase
 * auto generated base class for the model ChapterModel.
 */
export const ChapterModelBase = ModelBase.named('Chapter')
  .props({
    __typename: types.optional(types.literal('Chapter'), 'Chapter'),
    _id: types.union(types.undefined, types.null, types.string),
    completed: types.union(types.undefined, types.null, types.boolean),
    currentPosition: types.union(types.undefined, types.null, types.number),
    description: types.union(types.undefined, types.string),
    duration: types.union(types.undefined, types.number),
    membership: types.union(types.undefined, types.string),
    name: types.union(types.undefined, types.string),
    order: types.union(types.undefined, types.number),
    subtitlesUrl: types.union(types.undefined, types.string),
    thumbnailUrl: types.union(types.undefined, types.string),
    videoUrl: types.union(types.undefined, types.string),
    visibility: types.union(types.undefined, types.null, types.boolean),
    wpChapterId: types.union(types.undefined, types.null, types.string)
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ChapterModelSelector extends QueryBuilder {
  get _id() {
    return this.__attr('_id')
  }
  get completed() {
    return this.__attr('completed')
  }
  get currentPosition() {
    return this.__attr('currentPosition')
  }
  get description() {
    return this.__attr('description')
  }
  get duration() {
    return this.__attr('duration')
  }
  get membership() {
    return this.__attr('membership')
  }
  get name() {
    return this.__attr('name')
  }
  get order() {
    return this.__attr('order')
  }
  get subtitlesUrl() {
    return this.__attr('subtitlesUrl')
  }
  get thumbnailUrl() {
    return this.__attr('thumbnailUrl')
  }
  get videoUrl() {
    return this.__attr('videoUrl')
  }
  get visibility() {
    return this.__attr('visibility')
  }
  get wpChapterId() {
    return this.__attr('wpChapterId')
  }
}
export function selectFromChapter() {
  return new ChapterModelSelector()
}

export const chapterModelPrimitives =
  selectFromChapter()._id.completed.currentPosition.description.duration.membership.name.order.subtitlesUrl.thumbnailUrl
    .videoUrl.visibility.wpChapterId
